import { Component, OnInit } from '@angular/core';
import {
	Data, Subscription, DataLoaderService, CommonDataService, SortingService, AlternateOptionsService,
	PriceCalculationService, ProgressBarService, SummaryValidationService, SummaryService
} from '../service-call-index';
import { SummaryValidationComponent } from './../summary-validations/summary-validations.component';
import { AlternateScreenComponent } from '../../alternate-options/alternate-options.component';
@Component({
	selector: 'color-options',
	templateUrl: './color.template.html',
	styleUrls: ['./color.component.css'],
})

export class ColorOptions implements OnInit {
	public color: Data[];
	public addColorOptions: Data[];
	public saved: Data[];
	public toggleContViewColor: boolean = false;
	public currency: string;
	public colorSuggList = [];
	public errMessage;
	private subscription: Subscription;
	public lengthOfColor: number;

	constructor(private dataLoaderService: DataLoaderService, private commonDataService: CommonDataService,
		private summaryService: SummaryService, private summaryValidationService: SummaryValidationService,
		private priceCalculationService: PriceCalculationService, private sortingService: SortingService,
		private progressService: ProgressBarService, private alternateOptionsService: AlternateOptionsService,
		private summaryValidationComponent: SummaryValidationComponent,private alternateScreenComponent: AlternateScreenComponent) {
		this.currency = this.dataLoaderService.data.currencyType;
		this.color = this.dataLoaderService.data.color;
		this.addColorOptions = this.dataLoaderService.data.additionalColor;
	}


	ngOnInit() {
		this.summaryService.getSelectedOptions();
		this.summaryValidationService.getSelectedOptions();
		this.progressService.progressBarValidation();
		if (this.commonDataService.colorFlag) {
			this.toggleContViewColor = true;
		}

		//fetching length for displaying in HTML
		this.lengthOfColor = this.dataLoaderService.data.color.length;

		//On load	
		let color;
		this.color.forEach(element => {
			if (element.selected === true) {
				color = element;
				this.saved = color;
				this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalColor", data: [color] });
			}
		});

	}
	/**
	 * To select a color option and send the selected option to the Summary screen
	 * @param item of Data type
	 * @returns none
	 */
	selectColor(item) {
		setTimeout(() => {
			this.progressService.illuminateRed();
		}, 0);
		this.dataLoaderService.flagDictionary.loadingFlag = true;
		this.dataLoaderService.flagDictionary.resetColorFlag = false;
		this.progressService.illuminateYellow();
		this.dataLoaderService.flagDictionary.alternateOverlayFlag = true;
		let index: number = -1;
		if (this.dataLoaderService.vehicleInfo.urlFlag === '0' || this.dataLoaderService.vehicleInfo.urlFlag === '1') {
			let returnAlternateValues = this.alternateOptionsService.getAlternateOptionsNormal(item);
			returnAlternateValues.subscribe(
				alternateResponse => {
					if (alternateResponse.suggestions[0].addedCodes.length > 0 || alternateResponse.suggestions[0].removedCodes.length > 0) {
						this.colorSuggList = alternateResponse.suggestions;
						this.commonDataService.sendSuggestion(this.colorSuggList);
						this.openAlternateScreen();
						this.commonDataService.progressBarNewOrderColorFlag = true;
						this.dataLoaderService.flagDictionary.loadingFlag = false;
					}
					else {
						for (let i in this.color) {
							if (this.color[i].code === item.code) {
								this.color[i].selected = true;
								this.alternateScreenComponent.updatedPrices();
							//Updated prices from validation response
							for (let c in this.dataLoaderService.gccUpdatedPrices) {
								for(let k in this.color){
									if ((this.color[k].code == this.dataLoaderService.gccUpdatedPrices[c].code) && (this.color[k].codeType == this.dataLoaderService.gccUpdatedPrices[c].codeType)){
										this.color[k].price = this.dataLoaderService.gccUpdatedPrices[c].price;
									}
								}
							}
							this.dataLoaderService.previousExpertColor[0] = this.color[i];

							} else {
								this.color[i].selected = false;
								for (let i in this.dataLoaderService.data.color) {
									for (let s in this.dataLoaderService.gccUpdatedPrices) {
										if ((this.dataLoaderService.data.color[i].code == this.dataLoaderService.gccUpdatedPrices[s].code) && (this.dataLoaderService.data.color[i].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType)) {
											this.dataLoaderService.data.color[i].price = this.dataLoaderService.gccUpdatedPrices[s].price;
										}
									}
								}
							}
						
						}
						this.saved = item;
						

						this.commonDataService.progressBarNewOrderColorFlag = true;
						this.dataLoaderService.flagDictionary.alternateOverlayFlag = false;
						this.dataLoaderService.flagDictionary.loadingFlag = false;
						this.saveColor();
						if (this.commonDataService.progressBarNewOrderColorFlag == true && this.commonDataService.progressBarNewOrderUpholsteryFlag == true) {
							setTimeout(() => {
								this.progressService.illuminateGreen();
								this.dataLoaderService.flagDictionary.validated = true;
							}, 0);
						}
					}
					this.sortingService.sortCodes(this.color, true)

				},
				err => {
					if (err._body !== undefined) {
						this.errMessage = err._body;
						this.commonDataService.notifyErrorMsgItem(this.errMessage);
						this.openAlternateErrorScreen();
						this.dataLoaderService.flagDictionary.loadingFlag = false;
					}
				}
			);
		} else {
			for (let i in this.color) {
				if (this.color[i].code === item.code) {
					this.color[i].selected = true;
				} else {
					this.color[i].selected = false;
				}
				this.saved = item;
			}
			this.commonDataService.progressBarNewOrderColorFlag = true;
			this.dataLoaderService.flagDictionary.validated = false;
			this.dataLoaderService.flagDictionary.alternateOverlayFlag = false;
			this.dataLoaderService.flagDictionary.loadingFlag = false;
			this.sortingService.sortCodes(this.color, true)
			this.saveColor();
		}
		this.progressService.progressBarValidation();

	}

	/**
	 * To go to the next Tab: Additional Color tab when clicked on the Continue button
	 * @param none
	 * @returns none
	 */
	gotoNextTab() {
		if (this.dataLoaderService.data.vehInfo[0].model === 'SMRT' || this.dataLoaderService.data.additionalColor.length > 0) {
			this.commonDataService.notifyOther({ option: 'activeAddColor' });
		}
		else {
			this.commonDataService.notifyOther({ option: 'activeUpholstery' });
		}
	}
	saveColor() {
		if (this.saved !== undefined) {
			this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalColor", data: [this.saved] });
			this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertColor", data: [this.saved] });
			this.priceCalculationService.normalModePriceCalculation();
		}
		this.progressService.progressBarValidation();
	}
	openAlternateScreen() {
		if (this.dataLoaderService.vehicleInfo.urlFlag === '0' || this.dataLoaderService.vehicleInfo.urlFlag === '1') {
			this.dataLoaderService.flagDictionary.alternateErrorFlag = false;
			this.dataLoaderService.flagDictionary.alternateValidateFlag = true;
			this.progressService.illuminateRed();
		}
	}
	openAlternateErrorScreen() {
		this.dataLoaderService.flagDictionary.alternateErrorFlag = true;
		this.dataLoaderService.flagDictionary.alternateValidateFlag = false;
		this.progressService.illuminateRed();
	}
	validate() {
		this.summaryValidationComponent.alternateOptionsForURLFlag2Validate();

	}
}



// WEBPACK FOOTER //
// ./src/app/components/selectable-tabs/normal-screen-components/color/color.component.ts